import { useGetTenantSystemEndpointsOnline } from '@ori/static-api-client-react';
import { useConfiguration } from '../contexts';
export function useSafeUrl(baseUrl, path) {
    var tenant = useConfiguration().tenant;
    var _useGetTenantSystemEndpointsOnline = useGetTenantSystemEndpointsOnline(tenant, {}, {
        swr: {
            revalidateOnFocus: false,
            enabled: !baseUrl
        }
    }), marketBaseUrl = _useGetTenantSystemEndpointsOnline.data;
    var _ref;
    var finalBaseUrl = (_ref = baseUrl || (marketBaseUrl === null || marketBaseUrl === void 0 ? void 0 : marketBaseUrl.onlineUrl)) !== null && _ref !== void 0 ? _ref : '';
    var safeBaseUrl = finalBaseUrl.endsWith('/') ? finalBaseUrl : "".concat(finalBaseUrl, "/");
    return safeBaseUrl + path;
}
